// src/features/counter/counterSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// hooks
import {
  doc,
  getDoc,
  Timestamp,
  addDoc,
  collection,
  getDocs,
  where,
  query,
} from 'firebase/firestore';
//
import { db } from 'src/auth/context/jwt/firebase';

const initialState = {
  value: null,
  loading: false,
  error: null,
};

export const statisticSlice = createSlice({
  name: 'history',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRecentGameHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRecentGameHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getRecentGameHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const getRecentGameHistory = createAsyncThunk(
  'statistic/getRecentGameHistory',
  async ({ uid }) => {
    // const now = Timestamp.now();
    const sevenDaysAgo = Timestamp.fromDate(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));

    // Query the gameHistory subcollection for records in the last 7 days
    const historyRef = collection(db, 'users', uid, 'gameHistory');
    const q = query(historyRef, where('timestamp', '>=', sevenDaysAgo));

    const querySnapshot = await getDocs(q);

    const recentHistory = querySnapshot.docs.map((d) => {
      const data = d.data();

      // Convert Firestore timestamp to JavaScript Date
      if (data.timestamp) {
        data.timestamp =
          data.timestamp instanceof Timestamp
            ? data.timestamp.toDate().toISOString()
            : data.timestamp;
      }

      return data;
    });

    return recentHistory;
  }
);

export const addGameHistory = async (uid, gameData) => {
  const gameHistoryRef = collection(db, 'users', uid, 'gameHistory');
  await addDoc(gameHistoryRef, gameData);
};

// export const {} = statisticSlice.actions;
export default statisticSlice.reducer;
